/*upgrading-to-20*/
/*update-turbojson*/
/*add-a-packagemanager-field-to-root-packagejson*/
/*update-eslint-config-turbo*/
/*update-turbo-run-commands*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "升级",
  "description": "学习如何升级 `turbo` 以获取仓库的最新改进。"
};
export let structuredData = {
  "contents": [{
    "heading": "升级到-20-upgrading-to-20",
    "content": "¥Upgrading to 2.0"
  }, {
    "heading": "更新-turbojson-update-turbojson",
    "content": "¥Update turbo.json"
  }, {
    "heading": "更新-turbojson-update-turbojson",
    "content": "运行以下命令开始从 1.x 升级到 2.0："
  }, {
    "heading": "更新-turbojson-update-turbojson",
    "content": "¥Get started upgrading from 1.x to 2.0 by running:"
  }, {
    "heading": "更新-turbojson-update-turbojson",
    "content": "这将更新你的 turbo.json，使其涵盖从 1.x 到 2.0 的许多重大更改。"
  }, {
    "heading": "更新-turbojson-update-turbojson",
    "content": "¥This will update your turbo.json(s) for many of the breaking changes from 1.x to 2.0."
  }, {
    "heading": "更新-turbojson-update-turbojson",
    "content": "此外，工作区中任何没有 name 字段的 package.json 都会添加一个 name 字段。"
  }, {
    "heading": "更新-turbojson-update-turbojson",
    "content": "¥Additionally, a name field will be added to any package.json in the Workspace that doesn't have one."
  }, {
    "heading": "更新-turbojson-update-turbojson",
    "content": "你也可以单独手动运行每个 codemod。访问 codemods 页面 了解更多信息。"
  }, {
    "heading": "更新-turbojson-update-turbojson",
    "content": "¥You may also manually run each codemod individually. Visit the codemods\npage for more information."
  }, {
    "heading": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "¥Add a packageManager field to root package.json"
  }, {
    "heading": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "packageManager 字段 是 Node.js 生态系统中的一个约定，它定义了预期在工作区中使用的包管理器。"
  }, {
    "heading": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "¥The packageManager field is a convention from the Node.js ecosystem that defines which package manager is expected to be used in the Workspace."
  }, {
    "heading": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "Turborepo 2.0 要求你的工作区定义此字段，以提高代码库的稳定性和行为可预测性。如果你还没有锁文件，请将此字段添加到你的根 package.json 中："
  }, {
    "heading": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "¥Turborepo 2.0 requires that your Workspace define this field as a way to improve the stability and behavioral predictability of your codebase. If you do not have one already, add this field to your root package.json:"
  }, {
    "heading": "更新-eslint-config-turbo-update-eslint-config-turbo",
    "content": "¥Update eslint-config-turbo"
  }, {
    "heading": "更新-eslint-config-turbo-update-eslint-config-turbo",
    "content": "eslint-config-turbo 帮助识别需要添加到 env 键以进行缓存的环境变量。如果你正在使用它，请确保将其更新以匹配你的主版本。"
  }, {
    "heading": "更新-eslint-config-turbo-update-eslint-config-turbo",
    "content": "¥eslint-config-turbo helps identify environment variables that need to be added to the env key for caching. If you're using it, make sure you update it to match your major version."
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥Update turbo run commands"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "Turborepo 2.0 改进了 turbo run 命令的行为和正确性。以下列出了变更摘要，这些变更可能会或可能不会对你的代码库产生影响："
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥Turborepo 2.0 includes behavioral and correctness improvements with behavior of turbo run commands. Listed below is the summary of changes, which may or may not have an affect on your codebase:"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "环境变量的严格模式现已从松散模式 (PR) 改为默认模式"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥Strict Mode for environment variables is now the default, moving from Loose Mode (PR)"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "如果你的任务中的脚本似乎缺少环境变量，你可以根据每个命令使用 --env-mode 选项 来选择退出此行为，以进行增量迁移。我们建议你在任务中更新 env 键，以考虑其所有环境变量，这样你就可以尽快删除 --env-mode 选项。"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥If it appears that the scripts in your tasks are missing environment variables, you can opt back out of this behavior using the --env-mode option on a per-command basis to incrementally migrate. We encourage you to update the env key in your task to account for all of its environment variables so you can drop the --env-mode option as soon as possible."
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "如果你想将存储库的默认设置恢复为松散模式，你可以执行 使用 envMode 配置 操作。"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥If you'd like to set the default for the repository back to Loose Mode, you can do so using the envMode configuration."
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "工作区根目录现在是所有包（PR）的隐式依赖"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥Workspace root directory is now an implicit dependency of all packages (PR)"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "仓库的根目录中的代码应尽可能少，因为对根目录的更改会影响仓库中的所有任务。此外，如果你在工作区根目录中使用 内部软件包，更改这些依赖也会导致所有任务的缓存未命中。在这两种情况下，请考虑将代码移出根目录和 安装到包中 分支。"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥The repository should have as little code in the root as possible, since changes to the root can affect all tasks in your repository. Additionally, if you're using Internal Packages in the Workspace root, changes to those dependencies will also cause cache misses for all tasks. In both cases, consider moving the code out of the root and into a package."
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "已删除 --ignore，支持 --filter，并在下方绘制正确性变更图（PR）"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥--ignore removed in favor of --filter and graph correctness changes below (PR)"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "删除了 --scope 标志（自 1.2 版起已弃用）（PR）"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥Removed --scope flag (deprecated since 1.2) (PR)"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "根目录 package.json 中的 engines 字段现在用于哈希计算 (PR)"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥engines field in root package.json is now used in hashing (PR)"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "--filter 不再推断包名的命名空间（PR）"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥--filter no longer infers namespaces for package names (PR)"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "--filter 现在会在没有匹配的包名或目录时出错（PR）"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥--filter now errors when no package names or directories are matched (PR)"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "--only 限制任务依赖，而不是包依赖（PR）"
  }, {
    "heading": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "¥--only restricts task dependencies instead of package dependencies (PR)"
  }],
  "headings": [{
    "id": "升级到-20-upgrading-to-20",
    "content": "升级到 2.0 /*upgrading-to-20*/"
  }, {
    "id": "更新-turbojson-update-turbojson",
    "content": "更新 turbo.json /*update-turbojson*/"
  }, {
    "id": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "将 packageManager 字段添加到根 package.json /*add-a-packagemanager-field-to-root-packagejson*/"
  }, {
    "id": "更新-eslint-config-turbo-update-eslint-config-turbo",
    "content": "更新 eslint-config-turbo /*update-eslint-config-turbo*/"
  }, {
    "id": "更新-turbo-run-命令-update-turbo-run-commands",
    "content": "更新 turbo run 命令 /*update-turbo-run-commands*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Steps, Step} from '#components/steps';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#升级到-20-upgrading-to-20",
  title: _jsx(_Fragment, {
    children: "升级到 2.0 "
  })
}, {
  depth: 3,
  url: "#更新-turbojson-update-turbojson",
  title: _jsxs(_Fragment, {
    children: ["更新 ", _jsx("code", {
      children: "turbo.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
  title: _jsxs(_Fragment, {
    children: ["将 ", _jsx("code", {
      children: "packageManager"
    }), " 字段添加到根 ", _jsx("code", {
      children: "package.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#更新-eslint-config-turbo-update-eslint-config-turbo",
  title: _jsxs(_Fragment, {
    children: ["更新 ", _jsx("code", {
      children: "eslint-config-turbo"
    }), " "]
  })
}, {
  depth: 3,
  url: "#更新-turbo-run-命令-update-turbo-run-commands",
  title: _jsxs(_Fragment, {
    children: ["更新 ", _jsx("code", {
      children: "turbo run"
    }), " 命令 "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "升级到-20-upgrading-to-20",
      children: "升级到 2.0 "
    }), "\n", _jsx(_components.p, {
      children: "¥Upgrading to 2.0"
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "更新-turbojson-update-turbojson",
          children: ["更新 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["¥Update ", _jsx(_components.code, {
            children: "turbo.json"
          })]
        }), _jsx(_components.p, {
          children: "运行以下命令开始从 1.x 升级到 2.0："
        }), _jsx(_components.p, {
          children: "¥Get started upgrading from 1.x to 2.0 by running:"
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " dlx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @turbo/codemod"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " migrate"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " dlx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @turbo/codemod"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " migrate"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @turbo/codemod"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " migrate"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bunx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @turbo/codemod"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " migrate"
                    })]
                  })
                })
              })
            })
          })]
        }), _jsxs(_components.p, {
          children: ["这将更新你的 ", _jsx(_components.code, {
            children: "turbo.json"
          }), "，使其涵盖从 1.x 到 2.0 的许多重大更改。"]
        }), _jsxs(_components.p, {
          children: ["¥This will update your ", _jsx(_components.code, {
            children: "turbo.json"
          }), "(s) for many of the breaking changes from 1.x to 2.0."]
        }), _jsxs(_components.p, {
          children: ["此外，工作区中任何没有 ", _jsx(_components.code, {
            children: "name"
          }), " 字段的 ", _jsx(_components.code, {
            children: "package.json"
          }), " 都会添加一个 ", _jsx(_components.code, {
            children: "name"
          }), " 字段。"]
        }), _jsxs(_components.p, {
          children: ["¥Additionally, a ", _jsx(_components.code, {
            children: "name"
          }), " field will be added to any ", _jsx(_components.code, {
            children: "package.json"
          }), " in the Workspace that doesn't have one."]
        }), _jsxs(Callout, {
          type: "good-to-know",
          children: [_jsxs(_components.p, {
            children: ["你也可以单独手动运行每个 codemod。访问 ", _jsx(_components.a, {
              href: "/docs/reference/turbo-codemod#turborepo-2x",
              children: "codemods 页面"
            }), " 了解更多信息。"]
          }), _jsxs(_components.p, {
            children: ["¥You may also manually run each codemod individually. Visit ", _jsx(_components.a, {
              href: "/docs/reference/turbo-codemod#turborepo-2x",
              children: "the codemods\npage"
            }), " for more information."]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
          children: ["将 ", _jsx(_components.code, {
            children: "packageManager"
          }), " 字段添加到根 ", _jsx(_components.code, {
            children: "package.json"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["¥Add a ", _jsx(_components.code, {
            children: "packageManager"
          }), " field to root ", _jsx(_components.code, {
            children: "package.json"
          })]
        }), _jsxs(_components.p, {
          children: [_jsxs(_components.a, {
            href: "https://nodejs.cn/api/packages.html#packagemanager",
            children: [_jsx(_components.code, {
              children: "packageManager"
            }), " 字段"]
          }), " 是 Node.js 生态系统中的一个约定，它定义了预期在工作区中使用的包管理器。"]
        }), _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "https://nodejs.cn/api/packages.html#packagemanager",
            children: ["The ", _jsx(_components.code, {
              children: "packageManager"
            }), " field"]
          }), " is a convention from the Node.js ecosystem that defines which package manager is expected to be used in the Workspace."]
        }), _jsxs(_components.p, {
          children: ["Turborepo 2.0 要求你的工作区定义此字段，以提高代码库的稳定性和行为可预测性。如果你还没有锁文件，请将此字段添加到你的根 ", _jsx(_components.code, {
            children: "package.json"
          }), " 中："]
        }), _jsxs(_components.p, {
          children: ["¥Turborepo 2.0 requires that your Workspace define this field as a way to improve the stability and behavioral predictability of your codebase. If you do not have one already, add this field to your root ", _jsx(_components.code, {
            children: "package.json"
          }), ":"]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+ \"packageManager\": \"pnpm@9.2.0\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+ \"packageManager\": \"yarn@1.22.19\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+ \"packageManager\": \"npm@10.8.1\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+ \"packageManager\": \"bun@1.2.0\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "更新-eslint-config-turbo-update-eslint-config-turbo",
          children: ["更新 ", _jsx(_components.code, {
            children: "eslint-config-turbo"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["¥Update ", _jsx(_components.code, {
            children: "eslint-config-turbo"
          })]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/reference/eslint-config-turbo",
            children: _jsx(_components.code, {
              children: "eslint-config-turbo"
            })
          }), " 帮助识别需要添加到 ", _jsx(_components.a, {
            href: "/docs/reference/configuration#env",
            children: _jsx(_components.code, {
              children: "env"
            })
          }), " 键以进行缓存的环境变量。如果你正在使用它，请确保将其更新以匹配你的主版本。"]
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/reference/eslint-config-turbo",
            children: _jsx(_components.code, {
              children: "eslint-config-turbo"
            })
          }), " helps identify environment variables that need to be added to the ", _jsx(_components.a, {
            href: "/docs/reference/configuration#env",
            children: _jsx(_components.code, {
              children: "env"
            })
          }), " key for caching. If you're using it, make sure you update it to match your major version."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "更新-turbo-run-命令-update-turbo-run-commands",
          children: ["更新 ", _jsx(_components.code, {
            children: "turbo run"
          }), " 命令 "]
        }), _jsxs(_components.p, {
          children: ["¥Update ", _jsx(_components.code, {
            children: "turbo run"
          }), " commands"]
        }), _jsxs(_components.p, {
          children: ["Turborepo 2.0 改进了 ", _jsx(_components.code, {
            children: "turbo run"
          }), " 命令的行为和正确性。以下列出了变更摘要，这些变更可能会或可能不会对你的代码库产生影响："]
        }), _jsxs(_components.p, {
          children: ["¥Turborepo 2.0 includes behavioral and correctness improvements with behavior of ", _jsx(_components.code, {
            children: "turbo run"
          }), " commands. Listed below is the summary of changes, which may or may not have an affect on your codebase:"]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: ["环境变量的严格模式现已从松散模式 (", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8182",
                children: "PR"
              }), ") 改为默认模式"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥Strict Mode for environment variables is now the default, moving from Loose Mode (", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8182",
                children: "PR"
              }), ")"]
            }), "\n", _jsxs(_components.ul, {
              children: ["\n", _jsxs(_components.li, {
                children: ["\n", _jsxs(_components.p, {
                  children: ["如果你的任务中的脚本似乎缺少环境变量，你可以根据每个命令使用 ", _jsxs(_components.a, {
                    href: "/docs/reference/run#--env-mode-option",
                    children: [_jsx(_components.code, {
                      children: "--env-mode"
                    }), " 选项"]
                  }), " 来选择退出此行为，以进行增量迁移。我们建议你在任务中更新 ", _jsxs(_components.a, {
                    href: "/docs/reference/configuration#env",
                    children: [_jsx(_components.code, {
                      children: "env"
                    }), " 键"]
                  }), "，以考虑其所有环境变量，这样你就可以尽快删除 ", _jsx(_components.code, {
                    children: "--env-mode"
                  }), " 选项。"]
                }), "\n", _jsxs(_components.p, {
                  children: ["¥If it appears that the scripts in your tasks are missing environment variables, you can opt back out of this behavior using ", _jsxs(_components.a, {
                    href: "/docs/reference/run#--env-mode-option",
                    children: ["the ", _jsx(_components.code, {
                      children: "--env-mode"
                    }), " option"]
                  }), " on a per-command basis to incrementally migrate. We encourage you to update ", _jsxs(_components.a, {
                    href: "/docs/reference/configuration#env",
                    children: ["the ", _jsx(_components.code, {
                      children: "env"
                    }), " key"]
                  }), " in your task to account for all of its environment variables so you can drop the ", _jsx(_components.code, {
                    children: "--env-mode"
                  }), " option as soon as possible."]
                }), "\n"]
              }), "\n", _jsxs(_components.li, {
                children: ["\n", _jsxs(_components.p, {
                  children: ["如果你想将存储库的默认设置恢复为松散模式，你可以执行 ", _jsxs(_components.a, {
                    href: "/docs/reference/configuration#envmode",
                    children: ["使用 ", _jsx(_components.code, {
                      children: "envMode"
                    }), " 配置"]
                  }), " 操作。"]
                }), "\n", _jsxs(_components.p, {
                  children: ["¥If you'd like to set the default for the repository back to Loose Mode, you can do so ", _jsxs(_components.a, {
                    href: "/docs/reference/configuration#envmode",
                    children: ["using the ", _jsx(_components.code, {
                      children: "envMode"
                    }), " configuration"]
                  }), "."]
                }), "\n"]
              }), "\n"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: ["工作区根目录现在是所有包（", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8202",
                children: "PR"
              }), "）的隐式依赖"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥Workspace root directory is now an implicit dependency of all packages (", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8202",
                children: "PR"
              }), ")"]
            }), "\n", _jsxs(_components.ul, {
              children: ["\n", _jsxs(_components.li, {
                children: ["\n", _jsxs(_components.p, {
                  children: ["仓库的根目录中的代码应尽可能少，因为对根目录的更改会影响仓库中的所有任务。此外，如果你在工作区根目录中使用 ", _jsx(_components.a, {
                    href: "/docs/core-concepts/internal-packages",
                    children: "内部软件包"
                  }), "，更改这些依赖也会导致所有任务的缓存未命中。在这两种情况下，请考虑将代码移出根目录和 ", _jsx(_components.a, {
                    href: "/docs/crafting-your-repository/structuring-a-repository",
                    children: "安装到包中"
                  }), " 分支。"]
                }), "\n", _jsxs(_components.p, {
                  children: ["¥The repository should have as little code in the root as possible, since changes to the root can affect all tasks in your repository. Additionally, if you're using ", _jsx(_components.a, {
                    href: "/docs/core-concepts/internal-packages",
                    children: "Internal Packages"
                  }), " in the Workspace root, changes to those dependencies will also cause cache misses for all tasks. In both cases, consider moving the code out of the root and ", _jsx(_components.a, {
                    href: "/docs/crafting-your-repository/structuring-a-repository",
                    children: "into a package"
                  }), "."]
                }), "\n"]
              }), "\n"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: ["已删除 ", _jsx(_components.code, {
                children: "--ignore"
              }), "，支持 ", _jsx(_components.code, {
                children: "--filter"
              }), "，并在下方绘制正确性变更图（", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8201",
                children: "PR"
              }), "）"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.code, {
                children: "--ignore"
              }), " removed in favor of ", _jsx(_components.code, {
                children: "--filter"
              }), " and graph correctness changes below (", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8201",
                children: "PR"
              }), ")"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: ["删除了 ", _jsx(_components.code, {
                children: "--scope"
              }), " 标志（自 1.2 版起已弃用）（", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/7970",
                children: "PR"
              }), "）"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥Removed ", _jsx(_components.code, {
                children: "--scope"
              }), " flag (deprecated since 1.2) (", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/7970",
                children: "PR"
              }), ")"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: ["根目录 ", _jsx(_components.code, {
                children: "package.json"
              }), " 中的 ", _jsx(_components.code, {
                children: "engines"
              }), " 字段现在用于哈希计算 (", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8173",
                children: "PR"
              }), ")"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.code, {
                children: "engines"
              }), " field in root ", _jsx(_components.code, {
                children: "package.json"
              }), " is now used in hashing (", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8173",
                children: "PR"
              }), ")"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "--filter"
              }), " 不再推断包名的命名空间（", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8137",
                children: "PR"
              }), "）"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.code, {
                children: "--filter"
              }), " no longer infers namespaces for package names (", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8137",
                children: "PR"
              }), ")"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "--filter"
              }), " 现在会在没有匹配的包名或目录时出错（", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8142",
                children: "PR"
              }), "）"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.code, {
                children: "--filter"
              }), " now errors when no package names or directories are matched (", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8142",
                children: "PR"
              }), ")"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "--only"
              }), " 限制任务依赖，而不是包依赖（", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8163",
                children: "PR"
              }), "）"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.code, {
                children: "--only"
              }), " restricts task dependencies instead of package dependencies (", _jsx(_components.a, {
                href: "https://github.com/vercel/turborepo/pull/8163",
                children: "PR"
              }), ")"]
            }), "\n"]
          }), "\n"]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
